import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

const LaunchInfo = props => {
  return (
    <Fragment>
      <h3>Launch Info</h3>
      <ul>
        <li>
          <b>Return URL:</b> {props.log.params.launch_presentation_return_url}
        </li>
        <li>
          <b>Document Target:</b>{' '}
          {props.log.params.launch_presentation_document_target}
        </li>
        <li>
          <b>Launch URL:</b> {props.log.params.launch_url}
        </li>
      </ul>
    </Fragment>
  )
}
export default LaunchInfo

LaunchInfo.propTypes = {
  log: PropTypes.object,
}
